module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/testimonial-picture2-2559fd73e8b38e6958e9cbef8a7b96eb.png";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/testimonial-picture2.png
// module id = 1610
// module chunks = 0